import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { IAmanoOneAccessHolderUpdateResponse } from 'src/app/shared/code/interfaces/parcs-interfaces';

// 20260919 :: Ken Moss - Prompts for the Amano One access-holder mode when a termed Parker is being
// reactivated. Closes with the selected Amano One mode id, or 0 if the user cancels.
@Component({
  selector: 'app-dialog-amano-one-reactivate',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatFormFieldModule, MatSelectModule, FormsModule],
  templateUrl: './dialog-amano-one-reactivate.component.html',
  styleUrl: './dialog-amano-one-reactivate.component.scss'
})
export class DialogAmanoOneReactivateComponent {
  // Amano One mode id; 0 means nothing chosen yet. Working in ids avoids a second text/id mapping.
  modeSettingValue: number = 0;
  amanoOneAccessHolder: IAmanoOneAccessHolderUpdateResponse;

  get canContinue(): boolean {
    return this.modeSettingValue > 0;
  }
  

  constructor(
    public _dialogRef: MatDialogRef<DialogAmanoOneReactivateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDialogData,
  ) {
    this.amanoOneAccessHolder = data.amanoOneAccessHolder;
    // Preselect the parker's existing Amano One mode; an unmapped id leaves the list on "Select Mode".
    this.modeSettingValue = this.amanoOneAccessHolder.mode;
  }

  onModeChange(event: any) {
    this.modeSettingValue = event.value;
  }


}

export interface IDialogData{
  amanoOneAccessHolder: IAmanoOneAccessHolderUpdateResponse;
 }